import KnockOut from "knockout";
import BasePage from "@Scripts/Pages/BasePage";
import CartDetailViewModel from "@Scripts/ViewModels/CartDetailViewModel";

export default class CartDetailPage extends BasePage {
    public static async init() {
        await super.init();

        (<any>window).App.viewModels.page = new CartDetailViewModel();
        KnockOut.applyBindings((<any>window).App.viewModels.page, document.getElementById("Page"));
    }
}